
import { createGlobalStyle } from 'styled-components';

// This becomes the source of truth for the application
export const LightTheme = createGlobalStyle`
 :root {
    --brand-logo: var(--themePrimary);
    --themePrimary: #2583d5;
    --themePrimary2: #2583d5;
    --themePrimary3: #3a71b9;
    //--calendarBorder: rgba(232,17,35, 0.3);
    --calendarBorder: rgba(248,168,0,1);
    --themeSecondary: #4d5b86;
    --btn-grey: rgb(218, 220, 226);
    --themeBtnBlue: #1d88da;
    --neutralBg:#f8f8f8;
    --neutralPrimaryAlt:#616161;
    --neutralPrimary: #323130;
    --neutralSecondary: #605e5c;
    --neutralTertiary: #a19f9d;
    --neutralTertiaryAlt: #c8c6c4;
    --neutralQuaternary: #d2d0ce;
    --neutralQuaternaryAlt: #e1dfdd;
    --neutralLight: rgba(var(--palette-neutral-20), 1);
    --neutralLighter: #f3f2f1;
    --neutralLighterAlt: #faf9f8;
    --text-disabled-color: rgba(var(--palette-neutral-100), .38);
    --red: #df4557;
    --green: rgb(16, 124, 16);
    --communication-foreground: rgba(0, 90, 158, 1);
    --danger: rgb(209, 52, 56);
    --shift-open:#f9da4738;
    --shift-open-active: #ffecad;
    --shift-open-color: #000;
    --shift-filled: #ebf4fc;
    --shift-filled-active: #c1def4;
    --shift-filled-color: #000;
    --shift-published:#becbd53b;
    --shift-published-active:#becbd570;
    --shift-published-color: #000;
    --shift-unpublished-edit: #f9da474d;
    --shift-unpublished-edit-active: #ffecad;
    --shift-unpublished-edit-color: #000;
    --white-to-grey: #fff;
    --white-to-lightgrey: #fff;
    --white-to-transparent:#fff;
    --white-to-darkgrey: #fff;
    --darkgrey-to-white: rgb(36 41 50);

    --red-main: #994676;
    --red-main-color: #fff;
    --red-bg-color:#ebd3e1;
    --red-bg-color-hover:#e4c4d7;
    --red-color: #4a1636;
    --red-color-hover:#4a1636;
    --red-border-color:#ddb4cc;

    --blue-main: #416196;
    --blue-main-color: #fff;
    --blue-bg-color:#c7d3e7;
    --blue-bg-color-hover:#b8c7e1;
    --blue-color: #03204d;
    --blue-color-hover:#03204d;
    --blue-border-color:#a9bbda;

    --purple-main: #635194;
    --purple-main-color: #fff;
    --purple-bg-color: #e2deed;
    --purple-bg-color-hover:#d5cfe5;
    --purple-color: #433b60;
    --purple-color-hover:#433b60;
    --purple-border-color:#c8c0dd;

    --orange-main: #be6316;
    --orange-main-color: #fff;
    --orange-bg-color:#f6d1b2;
    --orange-bg-color-hover:#f4c69f;
    --orange-color: rgb(78 32 8);
    --orange-color-hover:rgb(78 32 8);
    --orange-border-color:#f2ba8c;

    --taupe-main: #cebcbc;
    --taupe-main-color: #2E2525;
    --taupe-bg-color:#cebcbc;
    --taupe-bg-color-hover:#c2adad;
    --taupe-color: #2E2525;
    --taupe-color-hover:#2E2525;
    --taupe-border-color:#bfa9a9;

    --slate-main: #848fa4;
    --slate-main-color: #153361;
    --slate-bg-color:#bcc2ce;
    --slate-bg-color-hover:#aeb5c4;
    --slate-color: #0F172A;
    --slate-color-hover:#0F172A;
    --slate-border-color:#a9afbc;

    --tan-main: #b18818;
    --tan-main-color: #fff;
    --tan-bg-color:#f2dca0;
    --tan-bg-color-hover:#f0d58e;
    --tan-color: rgb(94, 51, 0);
    --tan-color-hover:rgb(94, 51, 0);
    --tan-border-color:#edcf7d;

    --green-main: #6c7c60;
    --green-main-color: #fff;
    --green-bg-color:#dbe0d7;
    --green-bg-color-hover:#d0d6cb;
    --green-color: #263017;
    --green-color-hover:#263017;
    --green-border-color:#c5cdbe;

    --grey-main: #676e79;
    --grey-main-color: #fff;
    --grey-bg-color:#dee0e3;
    --grey-bg-color-hover:#d2d5d9;
    --grey-color: rgb(59, 64, 65);
    --grey-color-hover:rgb(59, 64, 65);
    --grey-border-color:#c6c9ce;

    --yellow-main: #d89d07;
    --yellow-main-color: #fff;
    --yellow-bg-color:#fdecc1;
    --yellow-bg-color-hover:#fce5ab;
    --yellow-color: #5c4201;
    --yellow-color-hover:#5c4201;
    --yellow-border-color:#fcdf96;

    --primaryblue-main: #567580;
    --primaryblue-main-color: #fff;
    --primaryblue-bg-color:#cedade;
    --primaryblue-bg-color-hover:#c1d0d5;
    --primaryblue-color: #153238;
    --primaryblue-color-hover:#153238;
    --primaryblue-border-color:#b4c7cd;

    --brown-main: #9d6d34;
    --brown-main-color: #fff;
    --brown-bg-color:#e8d3ba;
    --brown-bg-color-hover:#e3c9aa;
    --brown-color: rgb(96, 55, 7);
    --brown-color-hover:rgb(96, 55, 7);
    --brown-border-color:#debf9b;

    --teal-main:#3799a6;
    --teal-main-color: #fff;
    --teal-bg-color:#cceaee;
    --teal-bg-color-hover:#bbe3e8;
    --teal-color: #1f4546;
    --teal-color-hover:#1f4546;
    --teal-border-color:#abdce3;

    --pink-main: #d43616;
    --pink-main-color:#fff;
    --pink-bg-color:#fbded8;
    --pink-bg-color-hover:#f9ccc3;
    --pink-color: #7a3225;
    --pink-color-hover:#7a3225;
    --pink-border-color:#f7baae;

    --custom-bg-color:#d3dfe7d9;
    --custom-bg-color-hover:#c1d0d5;
    --custom-color: #153238;
    --custom-color-hover:#153238;

    --unasigned-bg-color:#f3cece;
    --unasigned-bg-color-hover:#f3cece;
    --unasigned-color: #420610;
    --unasigned-color-hover:#420610;












    --sub-subnav-bg: rgba(253, 252, 252, 1);

    --component-grid-row-hover-color: rgba(var(--palette-neutral-100), 0.04);
    --component-grid-selected-row-color: rgba(var(--palette-primary-tint-30), 1);
    --component-grid-focus-border-color: rgba(var(--palette-primary), 1);
    --component-grid-link-selected-row-color: var(--communication-foreground);
    --component-grid-link-hover-color: var(--communication-foreground);
    --component-grid-action-hover-color: rgba(var(--palette-neutral-8), 1);
    --component-grid-action-selected-cell-hover-color: rgba(var(--palette-primary-tint-30), 0.4);
    --component-grid-cell-bottom-border-color: rgba(var(--palette-neutral-8), 1);

    --palette-primary-darken-6: rgba(0, 103, 181, 1);
    --palette-primary-darken-10: rgba(0, 91, 161, 1);

    --palette-primary: 0, 120, 212;
    --palette-neutral-100: 0, 0, 0;
    --palette-neutral-80: 51, 51, 51;
    --palette-neutral-70: 76, 76, 76;
    --palette-neutral-60: 102, 102, 102;
    --palette-neutral-30: 166, 166, 166;
    --palette-neutral-20: 200, 200, 200;
    --palette-neutral-10: 218, 218, 218;
    --palette-neutral-8: 234, 234, 234;
    --palette-neutral-6: 239, 239, 239;
    --palette-neutral-4: 244, 244, 244;
    --palette-neutral-2: 248, 248, 248;
    --palette-neutral-0: 255, 255, 255;

    --palette-neutral-alpha-100: rgba(--palette-neutral-100, 1);
    --palette-neutral-alpha-80: rgba(--palette-neutral-80, 1);
    --palette-neutral-alpha-70: rgba(--palette-neutral-70, 1);
    --palette-neutral-alpha-60: rgba(--palette-neutral-60, 1);
    --palette-neutral-alpha-30: rgba(--palette-neutral-30, 1);
    --palette-neutral-alpha-20: rgba(--palette-neutral-20, 1);
    --palette-neutral-alpha-10: rgba(--palette-neutral-10, 1);
    --palette-neutral-alpha-8: rgba(--palette-neutral-8, 1);
    --palette-neutral-alpha-6: rgba(--palette-neutral-6, 1);
    --palette-neutral-alpha-4: rgba(--palette-neutral-4, 1);
    --palette-neutral-alpha-2: rgba(--palette-neutral-2, 1);
    --palette-neutral-alpha-0: rgba(--palette-neutral-0, 1);



    --palette-error: rgba(232, 17, 35, 1);
    --palette-error-6: rgba(203, 15, 31, 1);
    --palette-error-10: rgba(184, 14, 28, 1);
    --palette-black-alpha-0: rgba(var(--palette-neutral-100), 0);
    --palette-black-alpha-2: rgba(var(--palette-neutral-100), 0.02);
    --palette-black-alpha-4: rgba(var(--palette-neutral-100), 0.04);
    --palette-black-alpha-6: rgba(var(--palette-neutral-100), 0.06);
    --palette-black-alpha-8: rgba(var(--palette-neutral-100), 0.08);
    --palette-black-alpha-10: rgba(var(--palette-neutral-100), 0.10);
    --palette-black-alpha-20: rgba(var(--palette-neutral-100), 0.20);
    --palette-black-alpha-30: rgba(var(--palette-neutral-100), 0.30);
    --palette-black-alpha-60: rgba(var(--palette-neutral-100), 0.60);
    --palette-black-alpha-70: rgba(var(--palette-neutral-100), 0.70);
    --palette-black-alpha-80: rgba(var(--palette-neutral-100), 0.80);
    --palette-black-alpha-100: rgba(var(--palette-neutral-100), 1);

    --palette-accent1-light: 249, 235, 235;
    --palette-accent1: 218, 10, 0;
    --palette-accent1-dark: 168, 0, 0;
    --palette-accent2-light: 223, 246, 221;
    --palette-accent2: 186, 216, 10;
    --palette-accent2-dark: 16, 124, 16;
    --palette-accent3-light: 251, 242, 236;
    --palette-accent3: 214, 127, 60;
    --palette-accent3-dark: 171, 102, 48;

    --palette-accent1-alpha-light: rgba(-palette-accent1-light,1);
    --palette-accent1-alpha: rgba(--palette-accent1, 1);
    --palette-accent1-alpha-dark: rgba(--palette-accent1-dark, 1);
    --palette-accent2-alpha-light: rgba(--palette-accent2-light, 1);
    --palette-accent2-alpha: rgba(--palette-accent2, 1);
    --palette-accent2-alpha-dark: rgba(--palette-accent2-dark, 1);
    --palette-accent3-alpha-light: rgba( --palette-accent3-light, 1);
    --palette-accent3-alpha: rgba(--palette-accent3, 1);
    --palette-accent3-alpha-dark: rgba(--palette-accent3-dark, 1);

    --background-color: rgba(var(--palette-neutral-0), 1);
    --status-info-foreground: rgba(0, 120, 212, 1);
    --status-info-background: rgba(0, 120, 212, 1);
    --status-error-foreground: rgba(205, 74, 69, 1);
    --status-error-background: rgba(var(--palette-accent1-light), 1);
    --status-error-text: rgba(var(--palette-accent1), 1);
    --status-error-strong: rgba(var(--palette-accent1-dark), 1);
    --status-success-foreground: rgba(var(--palette-accent2-dark), 1);
    --status-success-background: rgba(var(--palette-accent2-light), 1);
    --status-warning-icon-foreground: rgba(177, 133, 37, 1);
    --status-warning-foreground: rgba(214, 127, 60, 1);
    --status-warning-background: rgba(var(--palette-accent3-light), 1);
    --status-warning-text: rgba(184, 94, 6, 1);
    --text-primary-color: rgba(var(--palette-neutral-100), .9);
    --text-secondary-color: rgba(var(--palette-neutral-100), .70);
    --text-disabled-color: rgba(var(--palette-neutral-100), .38);
    --text-on-communication-background: var(--background-color);
    --border-subtle-color: rgba(var(--palette-neutral-100), .08);
    --callout-background-color: var(--background-color);
    --callout-filtered-background-color: rgba(var(--palette-neutral-0), 0.86);
    --callout-shadow-color: rgba(0, 0, 0, .132);
    --callout-shadow-secondary-color: rgba(0, 0, 0, .108);
    --panel-shadow-color: rgba(0, 0, 0, .22);
    --panel-shadow-secondary-color: rgba(0, 0, 0, .18);
    --focus-border-color: rgba(var(--palette-primary), 1);
    --sub-nav-background: var(--background-color);
    --sub-nav-border-color: #dcdcdc;
    --nav-header-background: var(--background-color);
    --nav-header-item-hover-background: rgb(244, 244, 244);
    --nav-header-active-item-background: rgba(var(--palette-neutral-100), 0.08);
    --nav-header-text-primary-color: var(--text-primary-color);
    --nav-header-text-secondary-color: var(--text-secondary-color);
    --nav-header-text-disabled-color: var(--text-disabled-color);
    --nav-header-product-color: rgba(var(--palette-primary), 1);
    --nav-vertical-background-color: #313c59;
    --nav-vertical-item-hover-background: rgba(var(--palette-neutral-100), 0.04);
    --nav-vertical-active-group-background: rgba(var(--palette-neutral-100), 0.06);
    --nav-vertical-active-item-background: rgba(var(--palette-neutral-100), 0.12);
    --nav-vertical-text-primary-color: var(--text-primary-color);
    --nav-vertical-text-secondary-color: var(--text-secondary-color);


    --fui-themePrimary: #1f8de4;
    --fui-themeLighterAlt: #f5fafe;
    --fui-themeLighter: #d8ecfb;
    --fui-themeLight: #b7dbf7;
    --fui-themeTertiary: #73b9ee;
    --fui-themeSecondary: #389be6;
    --fui-themeDarkAlt: #1d80cc;
    --fui-themeDark: #186cac;
    --fui-themeDarker: #12507f;
    --fui-neutralLighterAlt: #faf9f8;
    --fui-neutralLighter: #f3f2f1;
    --fui-neutralLight: rgba(var(--palette-neutral-20), 1);
    --fui-neutralQuaternaryAlt: #e1dfdd;
    --fui-neutralQuaternary: #d0d0d0;
    --fui-neutralTertiaryAlt: #c8c6c4;
    --fui-neutralTertiary: #595959;
    --fui-neutralSecondary: #373737;
    --fui-neutralPrimaryAlt: #2f2f2f;
    --fui-neutralPrimary: #000000;
    --fui-neutralDark: #151515;
    --fui-black: #0b0b0b;
    --fui-white: #ffffff;

    --user-color-1: #394A59;
    --user-color-2: #115959;
    --user-color-3: #03A696;
    --user-color-4: #038C7F;
    --user-color-5: #394A59;
    --user-color-6: #394A59;
    --user-color-7: #115959;
    --user-color-8: #03A696;
    --user-color-9: #038C7F;
    --user-color-10: #394A59;

    --shift-color-1: #fff;
    --shift-color-2: #fff;
    --shift-color-3: #fff;
    --shift-color-4: #fff;
    --shift-color-5: #fff;
    --shift-color-6: #fff;
    --shift-color-7: #fff;
    --shift-color-8: #fff;
    --shift-color-9: #fff;
    --shift-color-10: #fff;














}
`

export const DarkTheme = createGlobalStyle`
 :root {
    --brand-logo:#3381be;
    --themePrimary: #459ee4;
    --neutralPrimaryAlt:#616161;
    --themePrimary2: #2583d5;
    --themePrimary3: #3a71b9;
    //--calendarBorder: rgba(232,17,35, 0.3);
    --calendarBorder: rgba(248,168,0,1);
    --themeSecondary: #4d5b86;
    --btn-grey: rgb(218, 220, 226);
    --themeBtnBlue: #1d88da;
    --neutralBg:rgba(var(--palette-neutral-2,248, 248, 248),1);
    --neutralPrimary: #323130;
    --neutralSecondary: #605e5c;
    --neutralTertiary: #a19f9d;
    --neutralTertiaryAlt: #c8c6c4;
    --neutralQuaternary: #d2d0ce;
    --neutralQuaternaryAlt: #e1dfdd;
    --neutralLight: rgba(var(--palette-neutral-20), 1);
    --neutralLighter: #f3f2f1;
    --neutralLighterAlt: #212121;
    --text-disabled-color: rgba(var(--palette-neutral-100), .38);
    --red: #df4557;
    --green: rgb(16, 124, 16);
    --communication-foreground: rgba(0, 90, 158, 1);
    --danger: rgb(209, 52, 56);
    --shift-open: #f9da474d;
    --shift-open-active: #ffecad;
    --shift-open-color: #000;
    --shift-filled: #deecf9;
    --shift-filled-active: #c1def4;
    --shift-filled-color: #000;
    --shift-published: #8787873b;
    --shift-published-active: #85858570;
    --shift-published-color: #000;
    --shift-unpublished-edit: #f9da474d;
    --shift-unpublished-edit-active: #ffecad;
    --shift-unpublished-edit-color: #000;
--white-to-grey: rgb(34, 38, 45);
--white-to-transparent:transparent;
    --white-to-lightgrey: rgb(52 58 68);
    --white-to-darkgrey: #fff;
    --darkgrey-to-white: rgb(36 41 50);

 --user-color-1: #394A59;
    --user-color-2: #115959;
    --user-color-3: #03A696;
    --user-color-4: #038C7F;
    --user-color-5: #394A59;
--sub-subnav-bg: var(--background-color);


        --palette-primary-darken-6: rgba(0, 103, 181, 1);
    --palette-primary-darken-10: rgba(0, 120, 212, 1);
    
    --palette-primary: 0, 91, 161;
    --palette-neutral-100: 255, 255, 255;
    --palette-neutral-80: 209, 210, 212;
    --palette-neutral-70: 186, 188, 191;
    --palette-neutral-60: 163, 166, 169;
    --palette-neutral-30: 95, 99, 105;
    --palette-neutral-20: 72, 77, 84;
    --palette-neutral-10: 49, 54, 62;
    --palette-neutral-8: 44, 50, 58;
    --palette-neutral-6: 40, 45, 54;
    --palette-neutral-4: 35, 41, 50;
    --palette-neutral-2: 35, 40, 49;
    --palette-neutral-0: 26, 32, 41;

    --palette-neutral-alpha-100: rgba(--palette-neutral-100, 1);
    --palette-neutral-alpha-80: rgba(--palette-neutral-80, 1);
    --palette-neutral-alpha-70: rgba(--palette-neutral-70, 1);
    --palette-neutral-alpha-60: rgba(--palette-neutral-60, 1);
    --palette-neutral-alpha-30: rgba(--palette-neutral-30, 1);
    --palette-neutral-alpha-20: rgba(--palette-neutral-20, 1);
    --palette-neutral-alpha-10: rgba(--palette-neutral-10, 1);
    --palette-neutral-alpha-8: rgba(--palette-neutral-8, 1);
    --palette-neutral-alpha-6: rgba(--palette-neutral-6, 1);
    --palette-neutral-alpha-4: rgba(--palette-neutral-4, 1);
    --palette-neutral-alpha-2: rgba(--palette-neutral-2, 1);
    --palette-neutral-alpha-0: rgba(--palette-neutral-0, 1);

    
    --palette-error: rgba(184, 14, 28, 1);
    --palette-error-6: rgba(203, 15, 31, 1);
    --palette-error-10: rgba(232, 17, 35, 1);
    --palette-black-alpha-0: rgba(var(--palette-neutral-100), 0);
    --palette-black-alpha-2: rgba(var(--palette-neutral-100), 0.02);
    --palette-black-alpha-4: rgba(var(--palette-neutral-100), 0.04);
    --palette-black-alpha-6: rgba(var(--palette-neutral-100), 0.08);
    --palette-black-alpha-8: rgba(var(--palette-neutral-100), 0.12);
    --palette-black-alpha-10: rgba(var(--palette-neutral-100), 0.18);
    --palette-black-alpha-20: rgba(var(--palette-neutral-100), 0.29);
    --palette-black-alpha-30: rgba(var(--palette-neutral-100), 0.40);
    --palette-black-alpha-60: rgba(var(--palette-neutral-100), 0.57);
    --palette-black-alpha-70: rgba(var(--palette-neutral-100), 0.7);
    --palette-black-alpha-80: rgba(var(--palette-neutral-100), 0.86);
    --palette-black-alpha-100: rgba(var(--palette-neutral-100), 1);

    --palette-accent1-light: 63, 40, 47;
    --palette-accent1: 241, 112, 123;
    --palette-accent1-dark: 241, 112, 123;
    --palette-accent2-light: 52, 61, 36;
    --palette-accent2: 146, 195, 83;
    --palette-accent2-dark: 146, 195, 83;
    --palette-accent3-light: 61, 54, 34;
    --palette-accent3: 253, 185, 19;
    --palette-accent3-dark: 253, 185, 19;

    --palette-accent1-alpha-light: rgba(-palette-accent1-light,1);
    --palette-accent1-alpha: rgba(--palette-accent1, 1);
    --palette-accent1-alpha-dark: rgba(--palette-accent1-dark, 1);
    --palette-accent2-alpha-light: rgba(--palette-accent2-light, 1);
    --palette-accent2-alpha: rgba(--palette-accent2, 1);
    --palette-accent2-alpha-dark: rgba(--palette-accent2-dark, 1);
    --palette-accent3-alpha-light: rgba( --palette-accent3-light, 1);
    --palette-accent3-alpha: rgba(--palette-accent3, 1);
    --palette-accent3-alpha-dark: rgba(--palette-accent3-dark, 1);

    --component-grid-row-hover-color: rgba(var(--palette-neutral-100), 0.04);
    --component-grid-selected-row-color: rgba(var(--palette-primary-tint-30), 1);
    --component-grid-focus-border-color: rgba(var(--palette-primary), 1);
    --component-grid-link-selected-row-color: var(--communication-foreground);
    --component-grid-link-hover-color: var(--communication-foreground);
    --component-grid-action-hover-color: rgba(var(--palette-neutral-8), 1);
    --component-grid-action-selected-cell-hover-color: rgba(var(--palette-primary-tint-30), 0.4);
    --component-grid-cell-bottom-border-color: rgba(var(--palette-neutral-8), 1);
    --colorNeutralForeground1: #d9d9d9;
    --background-color: rgba(var(--palette-neutral-0), 1);
    --status-info-foreground: rgba(97, 168, 255, 1);
    --status-info-background: rgba(0, 120, 212, 1);
    --status-error-foreground: rgba(var(--palette-accent1), 1);
    --status-error-background: rgba(var(--palette-accent1-light), 1);
    --status-error-text: rgba(var(--palette-accent1), 1);
    --status-error-strong: rgba(var(--palette-accent1-dark), 1);
    --status-success-foreground: rgba(var(--palette-accent2-dark), 1);
    --status-success-background: rgba(var(--palette-accent2-light), 1);
    --status-warning-icon-foreground: rgba(177, 133, 37, 1);
    --status-warning-foreground: rgba(var(--palette-accent3), 1);
    --status-warning-background: rgba(var(--palette-accent3-light), 1);
    --status-warning-text: rgba(var(--palette-accent3), 1);
    --text-primary-color: rgba(var(--palette-neutral-100), .85);
    --text-secondary-color: rgba(var(--palette-neutral-100), .85);
    --text-disabled-color: rgba(var(--palette-neutral-100), .5);
    --text-on-communication-background: var(--text-primary-color);
    --border-subtle-color: rgba(var(--palette-neutral-100), .08);
    --callout-background-color: rgba(var(--palette-neutral-6), 1);
    --callout-filtered-background-color: rgba(var(--palette-neutral-0), 0.80);
    --callout-shadow-color: rgba(0, 0, 0, .4);
    --callout-shadow-secondary-color: rgba(0, 0, 0, .32);
    --panel-shadow-color: rgba(0, 0, 0, .67);
    --panel-shadow-secondary-color: rgba(0, 0, 0, .53);
    --focus-border-color: rgba(var(--palette-primary-shade-10), 1);
    --sub-nav-background: rgba(var(--palette-neutral-2,248, 248, 248),1);
    --sub-nav-border-color:var(--palette-black-alpha-6,rgba(0, 0, 0, .1));
    --nav-header-background: var(--background-color);
    --nav-header-item-hover-background: rgba(var(--palette-neutral-100), 0.02);
    --nav-header-active-item-background: rgba(var(--palette-neutral-100), 0.08);
    --nav-header-text-primary-color: #f1f1f1;
    --nav-header-text-secondary-color: var(--text-secondary-color);
    --nav-header-text-disabled-color: var(--text-disabled-color);
    --nav-header-product-color: rgba(var(--palette-primary-shade-20), 1);
    --nav-vertical-background-color: #262d3d;
    --nav-vertical-item-hover-background: rgba(var(--palette-neutral-100), 0.04);
    --nav-vertical-active-group-background: rgba(var(--palette-neutral-100), 0.06);
    --nav-vertical-active-item-background: rgba(var(--palette-neutral-100), 0.12);
    --nav-vertical-text-primary-color: var(--text-primary-color);
    --nav-vertical-text-secondary-color: var(--text-secondary-color);
    --component-menu-selected-item-background: rgba(var(--palette-neutral-100), 0.04);
    --component-htmlEditor-background-color: rgba(255, 255, 255, 1);
    --component-htmlEditor-foreground-color: rgba(0, 0, 0, .9);



    --fui-themePrimary: #1f8de4;
    --fui-themeLighterAlt: #f5fafe;
    --fui-themeLighter: #d8ecfb;
    --fui-themeLight: #b7dbf7;
    --fui-themeTertiary: #73b9ee;
    --fui-themeSecondary: #389be6;
    --fui-themeDarkAlt: #1d80cc;
    --fui-themeDark: #186cac;
    --fui-themeDarker: #12507f;
    --fui-neutralLighterAlt: #272b34;
    --fui-neutralLighter: #262b33;
    --fui-neutralLight: #242931;
    --fui-neutralQuaternaryAlt: #22262e;
    --fui-neutralQuaternary: #20242c;
    --fui-neutralTertiaryAlt: #1f232a;
    --fui-neutralTertiary: #c8c8c8;
    --fui-neutralSecondary: #d0d0d0;
    --fui-neutralPrimaryAlt: #dadada;
    --fui-neutralPrimary: #ffffff;
    --fui-neutralDark: #f4f4f4;
    --fui-black: #f8f8f8;
    --fui-white: #282d36;















    --red-main: rgb(231, 72, 86);
    --red-bg-color:rgba(231, 65, 80, 0.24);
    --red-bg-color-hover:rgba(231, 65, 80, 0.34);
    --red-color: rgb(129, 40, 48);
    --red-color-hover:rgb(45, 14, 17);
    --orange-main: rgb(255, 140, 0);
    --orange-bg-color:rgba(255, 140, 0, 0.24);
    --orange-bg-color-hover:rgba(255, 140, 0, 0.34);
    --orange-color: rgb(94, 51, 0);
    --orange-color-hover:rgb(94, 51, 0);
    --blue-main: rgb(0, 188, 242);
    --blue-bg-color:rgba(0, 188, 242, 0.24);
    --blue-bg-color-hover:rgba(0, 188, 242, 0.34);
    --blue-color: rgb(0, 72, 93);
    --blue-color-hover:rgb(0, 72, 93);
    --purple-main: rgb(92, 0, 92);
    --purple-bg-color:rgba(92, 0, 92, 0.24);
    --purple-bg-color-hover:rgba(92, 0, 92, 0.34);
    --purple-color: rgb(112, 13, 112);
    --purple-color-hover:rgb(92, 0, 92);
    --tan-main: rgb(202, 80, 16);
    --tan-bg-color:rgba(202, 76, 10, 0.24);
    --tan-bg-color-hover:rgba(202, 76, 10, 0.34);
    --tan-color: rgb(113, 45, 9);
    --tan-color-hover:rgb(113, 45, 9);
    --green-main: rgb(11, 106, 11);
    --green-bg-color:rgba(8, 106, 8, 0.24);
    --green-bg-color-hover:rgba(8, 106, 8, 0.34);
    --green-color: rgb(8, 81, 8);
    --green-color-hover:rgb(6, 59, 6);
    --grey-main: rgb(160, 174, 178);
    --grey-bg-color:rgba(155, 173, 178, 0.24);
    --grey-bg-color-hover:rgba(155, 173, 178, 0.34);
    --grey-color: rgb(59, 64, 65);
    --grey-color-hover:rgb(59, 64, 65);
    --yellow-main: rgb(255, 241, 0);
    --yellow-bg-color:rgba(255, 241, 0, 0.24);
    --yellow-bg-color-hover:rgba(255, 241, 0, 0.34);
    --yellow-color: rgb(102, 96, 0);
    --yellow-color-hover:rgb(102, 96, 0);
    --primaryblue-main: #4576bd;





    --brown-main: rgb(171, 98, 13);
    --brown-bg-color:rgba(171, 96, 8, 0.24);
    --brown-bg-color-hover:rgba(171, 96, 8, 0.34);
    --brown-color: rgb(96, 55, 7);
    --brown-color-hover:rgb(96, 55, 7);

    --red-main: #6b3153;
    --red-main-color: #fff;
    --red-bg-color:#511e42;
    --red-bg-color-hover:#4d1c3f;
    --red-color: #f6dfed;
    --red-color-hover:#f6dfed;
    --red-border-color:#ecbad8;

    --blue-main: #2d4469;
    --blue-main-color: #fff;
    --blue-bg-color:#2c3c54;
    --blue-bg-color-hover:#2a3950;
    --blue-color: #d6e5fd;
    --blue-color-hover:#d6e5fd;
    --blue-border-color:#a9c9fb;

    --purple-main: #453968;
    --purple-main-color: #fff;
    --purple-bg-color:#38354c;
    --purple-bg-color-hover:#353248;
    --purple-color: #ebe9f1;
    --purple-color-hover:#ebe9f1;
    --purple-border-color:#323044;

    --orange-main: #85450f;
    --orange-main-color: #fff;
    --orange-bg-color:#573820;
    --orange-bg-color-hover:#53351e;
    --orange-color: #fbe4d9;
    --orange-color-hover:#fbe4d9;
    --orange-border-color:#f2ba8c;

    --taupe-main: #cebcbc;
    --taupe-main-color: #2E2525;
    --taupe-bg-color:#cebcbc;
    --taupe-bg-color-hover:#c2adad;
    --taupe-color: #2E2525;
    --taupe-color-hover:#2E2525;
    --taupe-border-color:#bfa9a9;

    --slate-main: #848fa4;
    --slate-main-color: #153361;
    --slate-bg-color:#bcc2ce;
    --slate-bg-color-hover:#aeb5c4;
    --slate-color: #0F172A;
    --slate-color-hover:#0F172A;
    --slate-border-color:#a9afbc;

    --tan-main: #7c5f11;
    --tan-main-color: #fff;
    --tan-bg-color:#56471f;
    --tan-bg-color-hover:#52431d;
    --tan-color: #ffecd5;
    --tan-color-hover:#ffecd5;
    --tan-border-color:#4d401c;

    --green-main: #4c5743;
    --green-main-color: #fff;
    --green-bg-color:#3a433c;
    --green-bg-color-hover:#374039;
    --green-color: #ebf1e1;
    --green-color-hover:#ebf1e1;
    --green-border-color:#d6e2c1;

    --grey-main: #484d55;
    --grey-main-color: #fff;
    --grey-bg-color:#dee0e3;
    --grey-bg-color-hover:#d2d5d9;
    --grey-color: rgb(59, 64, 65);
    --grey-color-hover:rgb(59, 64, 65);
    --grey-border-color:#c6c9ce;

    --yellow-main: #976e05;
    --yellow-main-color: #fff;
    --yellow-bg-color:#433714;
    --yellow-bg-color-hover:#403413;
    --yellow-color: #fff3d6;
    --yellow-color-hover:#fff3d6;
    --yellow-border-color:#ffe5a7;

    --primaryblue-main: #3c525a;
    --primaryblue-main-color: #fff;
    --primaryblue-color: #ebf3ff;
    --primaryblue-color-hover:#ebf3ff;
    --primaryblue-border-color:#b4c7cd;
    --primaryblue-bg-color:#36434d;
    --primaryblue-bg-color-hover:#36434d;


    --brown-main: #6e4c24;
    --brown-main-color: #fff;
    --brown-bg-color:#5e3708;
    --brown-bg-color-hover:#593408;
    --brown-color: #fcecd9;
    --brown-color-hover:#fcecd9;
    --brown-border-color:#553107;

    --teal-main:#276b74;
    --teal-main-color: #fff;
    --teal-bg-color:#1f3f47;
    --teal-bg-color-hover:#1d3c43;
    --teal-color:#e3f2f2;
    --teal-color-hover:#e3f2f2;
    --teal-border-color:#1c3940;

    --pink-main: #d43616;
    --pink-main-color:#fff;
    --pink-bg-color:#fbded8;
    --pink-bg-color-hover:#f9ccc3;
    --pink-color: #7a3225;
    --pink-color-hover:#7a3225;
    --pink-border-color:#f7baae;

    --custom-bg-color:#36414e;
    --custom-bg-color-hover:#333e4a;
    --custom-color: #dbe2e3;
    --custom-color-hover:#dbe2e3;

    --unasigned-bg-color:#622c38;
    --unasigned-bg-color-hover:#622c38;
    --unasigned-color: #fbd4db;
    --unasigned-color-hover:#fbd4db;
}
`